import { doc, increment, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../config/FirebaseConfig";

const ACCESS_COLLECTION = "access";
const ACCESS_THROTTLE_KEY = "sette_site_access_tracked_date_v2";

const toMonthId = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
};

const getTrackedDate = () => {
  if (typeof window === "undefined") {
    return "";
  }
  try {
    return window.localStorage.getItem(ACCESS_THROTTLE_KEY) || "";
  } catch (error) {
    return "";
  }
};

const markTrackedDate = (dateKey) => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(ACCESS_THROTTLE_KEY, dateKey);
  } catch (error) {
    void error;
  }
};

export const trackSiteAccess = async () => {
  const now = new Date();
  const dateKey = now.toISOString().slice(0, 10);
  if (getTrackedDate() === dateKey) {
    return;
  }

  try {
    await setDoc(
      doc(db, ACCESS_COLLECTION, toMonthId(now)),
      {
        count: increment(1),
        month: now.getMonth() + 1,
        year: now.getFullYear(),
        updatedAt: serverTimestamp(),
      },
      { merge: true },
    );
    markTrackedDate(dateKey);
  } catch (error) {
    console.error("Erro ao registrar acesso do site:", error);
  }
};
